module.exports = __webpack_public_path__ + "img/reset_password_sent.99af2e6d.svg";